/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionDocumentBody { 
    /**
     * Est-ce que le fichier doit être visible par les Professionnels de santé
     */
    visiblePS?: boolean;
    /**
     * Est-ce que le fichier doit être visible par le patient ou ses représentants légaux
     */
    visiblePatient?: boolean;
    /**
     * Est-ce que le fichier doit être visible par le professionnel de santé
     */
    VisiblePS?: boolean;
    /**
     * Paramètre optionnel à utiliser si la situation courante (\'#/components/schemas/CurrentSession\') est inférieur à \"SA05\"
     */
    contentTypeCode?: string;
}

